import {
  TStateCommunications,
  createStateSagaCommunications,
} from 'src/helpers/redux'

import { actions as sagaActions, PREFIX } from './actions'
import { IGlobalStore } from 'src/types/store'
import { IGetAvailableNumbersParams } from 'src/services/numbers'
import { IAvailableNumber, PlaceVariables } from './types'
import { IConnectedAccount } from '../account/state'
import { IAccount } from 'src/services/accounts'

export interface IStateData {
  accounts: {
    params: IGetAvailableNumbersParams
    data: IConnectedAccount[]
    cursor: string | null
    item?: IAccount
    /** Last search query used in getNumbers; empty when full list is loaded */
    listSearch: string
  }
  /**
   * Every number of the workspace, for the settings page. Kept apart from `accounts`:
   * that list is the own numbers the softphone picks its default number from.
   */
  workspaceAccounts: {
    data: IConnectedAccount[]
    cursor: string | null
    listSearch: string
  }
  availableNumbers?: IAvailableNumber[]
  availableRcNumbers?: IAvailableNumber[]
}

export interface IState {
  communication: TStateCommunications<typeof sagaActions>
  data: IStateData
}

export const initialState: IState = {
  communication: createStateSagaCommunications(sagaActions),

  data: {
    accounts: {
      params: {
        phoneNumberFilterType: PlaceVariables.START_WITH,
        phoneNumberFilterValue: '',
      },
      data: [],
      cursor: null,
      item: undefined,
      listSearch: '',
    },
    workspaceAccounts: {
      data: [],
      cursor: null,
      listSearch: '',
    },
    availableNumbers: [],
    availableRcNumbers: [],
  },
}

export type TGlobalStateWithService = IGlobalStore & {
  [PREFIX]: IState
}

export { PREFIX }
